import React, { PropTypes } from 'react'
import ComponentMenu from '../ComponentMenu'
import ProductCard from '../ProductCard'
import CenterRow from '../CenterRow'

function ProductsGrid({ pages, caption }) {
	return (
		<div className="gray-box">
			<CenterRow headline={caption} />
			<div className="container page products">
				<ComponentMenu className="row center-xs"  pages={pages} shuffle={false} fileTypes={['yaml']}>
					{page =>
						<ProductCard key={page.path} page={page} />
					}
				</ComponentMenu>
			</div>
		</div>
	)
}

ProductsGrid.propTypes = {
	pages: PropTypes.array.isRequired,
	caption: PropTypes.string
}

ProductsGrid.defaultProps = {
	caption: "Sonic Horn Models"
}

export default ProductsGrid



// WEBPACK FOOTER //
// ../components/ProductsGrid/index.js